import { render, staticRenderFns } from "./HomeM.vue?vue&type=template&id=3696f650&scoped=true&"
import script from "./HomeM.vue?vue&type=script&lang=js&"
export * from "./HomeM.vue?vue&type=script&lang=js&"
import style0 from "./HomeM.vue?vue&type=style&index=0&id=3696f650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3696f650",
  null
  
)

export default component.exports